import useAuth from "./hooks/useAuth";
import Router from "./routes";
import ThemeProvider from "./theme";
import ScrollToTop from "./components/ScrollToTop";
import NotistackProvider from "./components/NotistackProvider";
import ThemeColorPresets from "./components/ThemeColorPresets";
import ThemeLocalization from "./components/ThemeLocalization";
import MotionLazyContainer from "./components/animate/MotionLazyContainer";
import ConfirmDialog from "src/components/ConfirmDialog";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { Storage } from "./utils/storage";
import { CircularProgress } from "@mui/material";

/**
 t("shared.langpl")
 t("shared.langen")
 */

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false,
            staleTime: 30000,
        },
    },
});

export default function App() {
    const { contextLogin, contextCompanySet } = useAuth();
    const [initial, setInitial] = useState<boolean>(true);

    const userStorage = Storage.getItem("userState");
    const userCompany = Storage.getItem("currentCompany");

    useEffect(() => {
        if (
            userStorage &&
            userStorage.email &&
            userStorage.accessToken &&
            userStorage.refreshToken
        ) {
            contextLogin(userStorage.email, userStorage.accessToken, userStorage.refreshToken);
        }

        if (userCompany) {
            contextCompanySet({ ...userCompany });
        }

        if (initial) {
            setInitial(false);
        }
    }, [initial]);

    return (
        <ThemeProvider>
            <ThemeColorPresets>
                <ThemeLocalization>
                    <QueryClientProvider client={queryClient}>
                        <NotistackProvider>
                            <MotionLazyContainer>
                                <ConfirmDialog />
                                <ScrollToTop />

                                {!initial ? <Router /> : <CircularProgress />}
                                <ReactQueryDevtools initialIsOpen={false} />
                            </MotionLazyContainer>
                        </NotistackProvider>
                    </QueryClientProvider>
                </ThemeLocalization>
            </ThemeColorPresets>
        </ThemeProvider>
    );
}
